import { Bot, RefreshCw } from "lucide-react";
import { useCallback, useEffect, useState } from "react";

import { apiEndpoint, apiFetch } from "@/lib/api/client";

type ConnectionState = "connecting" | "ready" | "error";

export function SonnyChatScreen() {
  const [state, setState] = useState<ConnectionState>("connecting");
  const [frameKey, setFrameKey] = useState(0);

  const connect = useCallback(async () => {
    setState("connecting");
    try {
      await apiFetch<void>("/admin/sonny/session", { method: "POST" });
      setFrameKey((key) => key + 1);
      setState("ready");
    } catch {
      setState("error");
    }
  }, []);

  useEffect(() => {
    void connect();
  }, [connect]);

  if (state === "connecting") {
    return (
      <div
        role="status"
        className="h-full flex items-center justify-center bg-page text-ink-muted"
      >
        <span className="inline-flex items-center gap-8 type-label-md">
          <Bot size={18} aria-hidden /> Connecting Sonny…
        </span>
      </div>
    );
  }

  if (state === "error") {
    return (
      <div className="h-full flex items-center justify-center bg-page px-20">
        <div role="alert" className="max-w-content-sm text-center">
          <Bot size={28} className="mx-auto text-ink-muted" aria-hidden />
          <h1 className="type-heading-lg mt-12">Sonny is unavailable</h1>
          <p className="type-body-md text-ink-muted mt-6">
            The admin gateway could not connect to Sonny in this environment.
          </p>
          <button
            type="button"
            onClick={() => void connect()}
            className="mt-14 inline-flex items-center gap-6 rounded border border-line bg-raised px-12 py-8 type-label-sm hover:bg-sunken"
          >
            <RefreshCw size={14} aria-hidden /> Try again
          </button>
        </div>
      </div>
    );
  }

  return (
    <iframe
      key={frameKey}
      title="Sonny company AI"
      src={apiEndpoint("/admin/sonny/app/")}
      className="block h-full w-full border-0 bg-page"
      sandbox="allow-downloads allow-forms allow-popups allow-same-origin allow-scripts"
    />
  );
}
